import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { Album } from 'interfaces';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import usaFlag from 'assets/us.svg';
import japanFlag from 'assets/jp.svg';

import {
  Wrapper,
  AlbumsWrapper,
  AlbumItem,
  AlbumName,
  AlbumDate,
  AlbumPhoto
} from './Albums.styles';

export interface AlbumProps {
  albums: Album[];
}

const Albums = (props: AlbumProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Wrapper>
      <p>{intl.formatMessage({ id: 'albums.description' }, {
        bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
      })}</p>
      <AlbumsWrapper>
      {
        props.albums.map((album) => (
          <Link
            to={`/albums/${album.id}${album.international ? '?international=true' : ''}`}
            key={`${album.id}${album.international ? '-international' : ''}`}
          >
            <AlbumItem>
              <AlbumPhoto sorce={`/albums/${album.id}${album.international ? '-international' : ''}.jpg`}></AlbumPhoto>
              <AlbumDate>
                {intl.formatMessage({ id: 'albums.releaseDate' })}{' '}
                {intl.formatDate(new Date(album.releaseDate), {
                  year: "numeric",
                  month: "short",
                  day: "numeric"
                })}
                {
                  album.typeId !== 'single' ? (
                    <img
                      src={album.international ? usaFlag : japanFlag}
                      alt={
                        album.international
                          ? intl.formatMessage({ id: 'albums.details.internationalVersion' })
                          : intl.formatMessage({ id: 'albums.details.japanVersion' })
                      }
                    />
                  ) : null
                }
              </AlbumDate>
              <AlbumName>
                {locale === AppLocale.EN ? album.englishName : album.name}
              </AlbumName>
            </AlbumItem>
          </Link>
        ))
      }
      </AlbumsWrapper>
    </Wrapper>
  );
};

export default Albums;
